import React, { useState, useEffect } from "react";
import AnunciosIMG from "./img/anuncios1.jpg";
import { Typography, CircularProgress, Alert, Box } from "@mui/material";

function Anuncios() {
  const [pdfData, setPdfData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    fetchPDFs();
  }, []);

  const fetchPDFs = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        "https://iglesiaevangelicadelafe.com/api-church/get_pdfs.php",
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      console.log("Response status:", response.status);
      console.log("Response headers:", response.headers);

      if (!response.ok) {
        throw new Error(
          `HTTP error! status: ${response.status} - ${response.statusText}`
        );
      }

      const data = await response.json();
      console.log("PDF API response:", data);

      if (data.success && data.data && data.data.length > 0) {
        setPdfData(data);
        // Use the latest_pdf if available, otherwise use the first one
        const latestPdf = data.latest_pdf || data.data[0];
        setSelectedPdf(latestPdf);
        console.log("Selected PDF (latest):", latestPdf);
      } else {
        setError("No PDFs available at the moment.");
      }
    } catch (error) {
      console.error("Error fetching PDFs:", error);

      // More specific error messages
      if (error.message.includes("Failed to fetch")) {
        setError(
          "CORS Error: Unable to connect to the server. Please check your server configuration."
        );
      } else if (error.message.includes("HTTP error! status: 404")) {
        setError("API endpoint not found. Please check the URL.");
      } else if (error.message.includes("HTTP error! status: 500")) {
        setError("Server error. Please check your PHP configuration.");
      } else {
        setError(`Failed to load PDFs: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch only the latest PDF
  const fetchLatestPDF = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        "https://iglesiaevangelicadelafe.com/api-church/get_latest_pdf.php",
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP error! status: ${response.status} - ${response.statusText}`
        );
      }

      const data = await response.json();
      console.log("Latest PDF API response:", data);

      if (data.success && data.data) {
        setSelectedPdf(data.data);
        console.log("Latest PDF loaded:", data.data);
      } else {
        setError("No latest PDF available.");
      }
    } catch (error) {
      console.error("Error fetching latest PDF:", error);
      setError(`Failed to load latest PDF: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handlePdfSelect = (pdf) => {
    console.log("Selecting PDF:", pdf);
    setSelectedPdf(pdf);
  };

  return (
    <>
      <div className="img-container" style={{ position: "relative" }}>
        <img
          src={AnunciosIMG}
          alt="iglesia-la-fe"
          style={{ objectPosition: "top" }}
        />
        <Typography
          variant="h1"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
            zIndex: 1,
          }}
        >
          Anuncios
        </Typography>
      </div>

      <section
        className="page-section"
        style={{ minHeight: "100vh", padding: "2rem 0" }}
      >
        <div className="container">
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="60vh"
              flexDirection="column"
              gap={2}
            >
              <CircularProgress
                size={60}
                style={{ color: "var(--primary-color)" }}
              />
              <Typography
                variant="h6"
                style={{ color: "var(--primary-color)" }}
              >
                Cargando anuncios...
              </Typography>
            </Box>
          ) : error ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="60vh"
              flexDirection="column"
              gap={2}
            >
              <Alert severity="error" style={{ maxWidth: "500px" }}>
                {error}
              </Alert>
              <button
                onClick={fetchPDFs}
                style={{
                  padding: "12px 24px",
                  backgroundColor: "var(--primary-color)",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "background-color 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "var(--secondary-color)")
                }
                onMouseOut={(e) =>
                  (e.target.style.backgroundColor = "var(--primary-color)")
                }
              >
                Intentar de nuevo
              </button>
            </Box>
          ) : pdfData && selectedPdf ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
            >
              {/* Debug Info
              <div
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: "1rem",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontFamily: "monospace",
                }}
              >
                <strong>Debug Info:</strong>
                <br />
                PDF URL: {selectedPdf.url}
                <br />
                PDF Name: {selectedPdf.name}
                <br />
                PDF Type: {selectedPdf.type}
              </div> */}

              {/* PDF List
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  padding: "1rem 0",
                }}
              >
                {pdfData.data.map((pdf, index) => (
                  <button
                    key={index}
                    onClick={() => handlePdfSelect(pdf)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      padding: "12px 20px",
                      backgroundColor:
                        selectedPdf === pdf
                          ? "var(--primary-color)"
                          : "transparent",
                      color:
                        selectedPdf === pdf ? "white" : "var(--primary-color)",
                      border: `2px solid var(--primary-color)`,
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      transition: "all 0.3s ease",
                      minWidth: "200px",
                      justifyContent: "center",
                    }}
                    onMouseOver={(e) => {
                      if (selectedPdf !== pdf) {
                        e.target.style.backgroundColor = "var(--primary-color)";
                        e.target.style.color = "white";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (selectedPdf !== pdf) {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "var(--primary-color)";
                      }
                    }}
                  >
                    <DescriptionIcon />
                    {pdf.name || `PDF ${index + 1}`}
                  </button>
                ))}
              </div> */}

              {/* PDF Viewer */}
              <div
                style={{
                  height: "70vh",
                  width: "100%",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <iframe
                  src={`${selectedPdf.url}#toolbar=1&navpanes=1&scrollbar=1`}
                  width="100%"
                  height="100%"
                  style={{
                    border: "none",
                    borderRadius: "0",
                    display: "block",
                  }}
                  title={selectedPdf.name || "PDF Viewer"}
                  onError={(e) => {
                    console.error("PDF iframe error:", e);
                    setError("Error loading PDF. Please try again.");
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      backgroundColor: "#f5f5f5",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <Typography variant="h6" style={{ color: "#666" }}>
                      Tu navegador no puede mostrar PDFs
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ color: "#666", textAlign: "center" }}
                    >
                      {selectedPdf.name}
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}
                    >
                      <a
                        href={selectedPdf.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          padding: "12px 24px",
                          backgroundColor: "var(--primary-color)",
                          color: "white",
                          textDecoration: "none",
                          borderRadius: "8px",
                          fontWeight: "bold",
                          transition: "background-color 0.3s ease",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.backgroundColor =
                            "var(--secondary-color)")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.backgroundColor =
                            "var(--primary-color)")
                        }
                      >
                        Abrir en nueva pestaña
                      </a>
                      <a
                        href={selectedPdf.url}
                        download={selectedPdf.name}
                        style={{
                          padding: "12px 24px",
                          backgroundColor: "var(--secondary-color)",
                          color: "white",
                          textDecoration: "none",
                          borderRadius: "8px",
                          fontWeight: "bold",
                          transition: "background-color 0.3s ease",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.backgroundColor =
                            "var(--primary-color)")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.backgroundColor =
                            "var(--secondary-color)")
                        }
                      >
                        Descargar PDF
                      </a>
                    </div>
                  </div>
                </iframe>
              </div>

              {/* PDF Info */}
              {/* <div
                style={{
                  textAlign: "center",
                  padding: "1rem",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    color: "var(--primary-color)",
                    marginBottom: "0.5rem",
                  }}
                >
                  {selectedPdf.name || "Anuncio"}
                </Typography>
                <Typography variant="body2" style={{ color: "#666" }}>
                  Haz clic en los botones de arriba para ver diferentes anuncios
                </Typography>
              </div> */}
            </div>
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="60vh"
              flexDirection="column"
              gap={2}
            >
              <Typography
                variant="h6"
                style={{ color: "var(--primary-color)" }}
              >
                No hay anuncios disponibles en este momento
              </Typography>
              <Typography variant="body1" style={{ color: "#666" }}>
                Vuelve más tarde para ver nuevos anuncios
              </Typography>
            </Box>
          )}
        </div>
      </section>
    </>
  );
}

export default Anuncios;
